module.exports = __webpack_public_path__ + "static/pinkhearttaggie-11410cb0963afcf0bfb4c94b280dd6c0.png";